import { Box, ColorOptions, SpacerNew, TextNew } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { useEffect, useRef, useState } from 'react'
import { NativeSyntheticEvent, TextInput as RNTextInput, TextInputKeyPressEventData } from 'react-native'

interface props {
  onChange: any
  value?: string
  error?: string
  touched?: boolean
  label?: string
}

const TimeInput = ({ value, error, touched, onChange, label }: props) => {
  const [hour, setHour] = useState<string>(value?.split(':')?.[0] ?? '')
  const [mins, setMins] = useState<string>(value?.split(':')?.[1] ?? '')

  useEffect(() => {
    const hh = value?.split(':')?.[0] ?? ''
    const mm = value?.split(':')?.[1] ?? ''
    if (hh !== hour) {
      setHour(hh)
    }
    if (mm !== mins) {
      setMins(mm)
    }
  }, [value])

  useEffect(() => {
    if (hour?.length === 0 || mins?.length === 0) {
      onChange('')
    } else {
      onChange(`${hour}:${mins}:00`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hour, mins])

  const ref = useRef<RNTextInput>(null)
  const hoursRef = useRef<RNTextInput>(null)
  const handleHourChange = (hValue: string) => {
    const regex = /^(0?[1-9]|1?[1-9]|2?[0123])$/
    if (hValue.length >= 0 && hValue.length <= 2) {
      if (regex.test(hValue) || hValue.length === 0) {
        setHour(hValue)
      } else {
        hour ? setHour('00') : setHour('')
      }
    } else {
      ref?.current?.focus()
      const min = Number(hValue)
      if (!isNaN(min)) {
        setMins(hValue.toString().slice(2))
      }
    }
  }

  const handleOnBlur = (val: string | undefined, isHour: boolean) => {
    if (val?.length === 1 && Number(val) <= 9) {
      isHour ? setHour(`0${val}`) : setMins(`0${val}`)
    }
  }
  const handleMinsChange = (minValue: string) => {
    if (minValue.length === 1 && parseInt(minValue, 10) <= 9) {
      setMins(minValue)
    } else {
      const reg = /[0-5][0-9]/
      if (reg.test(minValue)) {
        setMins(minValue)
      } else {
        if (minValue?.length > 0) {
          setMins('00')
        } else {
          setMins('')
        }
      }
    }
  }

  const onDeleteKeyPress = ({ nativeEvent }: NativeSyntheticEvent<TextInputKeyPressEventData>) => {
    if (nativeEvent?.key === 'Backspace' && mins?.length === 0) {
      hoursRef?.current?.focus()
    }
  }

  return (
    <>
      <TextNew title={label} fontSize={12} fontFamily={'jiotype-medium'} color={'PRIMARY_GREY'} />
      <Box
        flexDirection={'row'}
        borderWidth={1}
        borderRadius={4}
        align={'center'}
        marginTop={8}
        ph={12}
        pv={8}
        bg={'WHITE'}
        borderColor={'PRIMARY_GREY' as ColorOptions}>
        <>
          <TextInputNew
            label={''}
            innerRef={hoursRef}
            placeholder={'HH'}
            editable={true}
            borderColor={'TRANSPARENT'}
            showBottomLine={false}
            textWidth={20}
            fontSize={12}
            fontWeight={'500'}
            color={'BLUE'}
            placeholderTextColor={'BLUE'}
            focusBorderColor={'TRANSPARENT'}
            value={hour}
            onChange={handleHourChange}
            onBlur={() => handleOnBlur(hour, true)}
          />
          <TextNew title={':'} fontSize={12} fontWeight={'500'} />
          <TextInputNew
            innerRef={ref}
            label={''}
            placeholder={'MM'}
            editable={true}
            borderColor={'TRANSPARENT'}
            showBottomLine={false}
            textWidth={22}
            fontSize={12}
            fontWeight={'500'}
            color={'BLACK_21'}
            placeholderTextColor={'BLACK_21'}
            focusBorderColor={'TRANSPARENT'}
            maxLength={2}
            value={mins}
            onChange={handleMinsChange}
            onKeyPress={onDeleteKeyPress}
            onBlur={() => handleOnBlur(mins, false)}
          />
        </>
      </Box>
      {error && touched && (
        <>
          <SpacerNew size={2} />
          <TextNew color="ERROR" type="body12">
            {error}
          </TextNew>
        </>
      )}
    </>
  )
}

export { TimeInput }
